import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import styles from './index.module.css';
import NotFound from "../components/NotFound";
import Footer from "../components/Footers";
import UserSidebar from "../components/Sidebar/UserSidebar";
import NormalUserRoutes from "../routes/NormalUserRoutes";
import EntityAdminHeader from "../components/Header/EntityAdminHeader";

const NormalUserLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    return (
        <div className={styles.appContainer}>
            <UserSidebar  isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar}/>
            <div className={styles.main}>                
            <EntityAdminHeader toggleSidebar={toggleSidebar}/>
            <div className={styles.content}>
                <Routes>
                    {NormalUserRoutes.map((prop, key) => (
                        <Route path={prop.path} element={prop.element} key={key} />
                    ))}
                    <Route path="*" element={<div><NotFound/></div>} />
                </Routes>
                <Footer/>        
            </div>    
            </div>
        </div>
    );
};

export default NormalUserLayout;
